
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LayoutItemProps } from ".";
import { loading, find } from "store/layout";

interface ApiLayoutFindByIdInputProps {
    id: number;
}

type ApiLayoutFindOutputProps = OutputBaseProps<{ item: LayoutItemProps; }, ApiLayoutFindByIdInputProps>

export const apiLayoutFindById = async (data: ApiLayoutFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLayoutFindOutputProps>(`/api/layout/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiLayoutFindByCodeInputProps {
    code: string;
}

export const apiLayoutFindByCode = async (data: ApiLayoutFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLayoutFindOutputProps>(`/api/layout/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};